
import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';

Vue.use(VueCompositionAPI);

Vue.config.productionTip = false;
if (window.sbvrenv.NODE_ENV !== 'production') Vue.config.devtools = true;
